import styled from '@emotion/styled';

export const HorizontalContainer = styled.div<{ gap?: string }>`
  display: flex;
  gap: ${({ gap }) => gap ?? '0px'};
`;
